import React from 'react';
import { observer } from 'mobx-react-lite';
import Popup from '../../../../../components/common-components/pop-up/Popup';
import CommonButton from '../../../../../components/common-components/button/CommonButton';
import './DeleteConfirmationDialog.css';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Silme Onayı',
}) => {
  const handleConfirmClick = () => {
    onConfirm();
  };

  const handleCancelClick = () => {
    onClose();
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <CommonButton type="cancel" onClick={handleCancelClick}>
            Hayır
          </CommonButton>
          <CommonButton type="delete" onClick={handleConfirmClick}>
            Evet
          </CommonButton>
        </>
      }
    >
      <div className="delete-confirmation-container">
        <p>Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</p>
      </div>
    </Popup>
  );
};

export default observer(DeleteConfirmationDialog);
